import { cn, Input, Text } from '@ctct/summit-core';
import { type ComponentProps, forwardRef } from 'react';

import { getDisableAutofillProps } from '../../../utils';

type PhoneNumberInputProps = ComponentProps<typeof Input> & {
  phoneNumberConfig: {
    countryCode?: string;
    nationalNumber?: string;
  };
  shouldDisableAutofill: boolean;
};

const PhoneNumberInput = forwardRef<HTMLInputElement, PhoneNumberInputProps>(
  (
    {
      disabled: isDisabled,
      className,
      phoneNumberConfig: { countryCode, nationalNumber },
      shouldDisableAutofill,
      ...props
    },
    ref
  ) => {
    return (
      <Input
        startAdornment={
          countryCode && (
            <Text
              color="dark"
              className={cn(
                'r:inline-flex r:pl-1.5',
                !props.value && 'r:text-(--text-placeholder)'
              )}
            >
              {countryCode}
            </Text>
          )
        }
        className={cn(
          'r:rounded-l-none',
          countryCode?.length === 2 && 'r:pl-8',
          countryCode?.length === 3 && 'r:pl-11',
          countryCode?.length === 4 && 'r:pl-[3.25rem]'
        )}
        {...props}
        {...getDisableAutofillProps(shouldDisableAutofill)}
        ref={ref}
        type="tel"
        placeholder={nationalNumber}
        disabled={isDisabled}
      />
    );
  }
);

export { PhoneNumberInput };
